import React, { useState, useCallback } from 'react';
import { Trans } from 'react-i18next';
import { makeBreadcrumbs, makeTabs } from '../constants';

export default ({ user, isNew }) => {
  const breadcrumbs = makeBreadcrumbs(user);
  const tabs = makeTabs(user);
  const [selectedTab, selectTab] = useState(tabs[0]);

  const handleTabSelect = useCallback(tab => selectTab(tab), []);

  const title = isNew ? <Trans>USER_ADD</Trans> : <Trans>USER_EDIT</Trans>;
  const loading = !isNew && !user.id;

  return [
    {
      isNew,
      title,
      tabs,
      breadcrumbs,
      selectedTab,
      loading,
    },
    { handleTabSelect },
  ];
};
